import React, { ReactNode } from "react";
import "./App.scss";
import { BrowserRouter } from "react-router-dom";
import { RoleRouter } from "./app/route/RoleRouter";
import { Paths } from "./Paths";
import { GlobalHeader } from "./app/view/header/GlobalHeader";
import { InformationPage } from "./app/view/information/InformationPage";
import { NotificationEmailPage } from "./app/view/user/NotificationEmailPage";
import { AdminIndexPage } from "./app/view/admin/AdminIndexPage";
import { AdminServiceProviderListPage } from "./app/view/admin/service_provider/AdminServiceProviderListPage";
import { AdminServiceProviderUpdatePage } from "./app/view/admin/service_provider/AdminServiceProviderUpdatePage";
import { AdminServiceProviderAddPage } from "./app/view/admin/service_provider/AdminServiceProviderAddPage";
import { AdminUserListPage } from "./app/view/admin/user/AdminUserListPage";
import { AdminUserAddPage } from "./app/view/admin/user/AdminUserAddPage";
import { AdminUserUpdatePage } from "./app/view/admin/user/AdminUserUpdatePage";
import { AdminCareRecipientListPage } from "./app/view/admin/care_recipient/AdminCareRecipientListPage";
import { AdminCareRecipientEditPage } from "./app/view/admin/care_recipient/AdminCareRecipientEditPage";
import { AdminCareRecipientAddPage } from "./app/view/admin/care_recipient/AdminCareRecipientAddPage";
import { AdminCareCommentAddPage } from "./app/view/admin/care_comment/AdminCareCommentAddPage";
import { InformationAddPage } from "./app/view/information/InformationAddPage";
import { InformationListPage } from "./app/view/information/InformationListPage";
import { NotFoundPage } from "./app/view/NotFoundPage";
import { CareRecipientListPage } from "./app/view/care_recipient/CareRecipientListPage";
import { NotRegistrationPage } from "./app/view/NotRegistrationPage";
import { RootRouter } from "./app/route/RootRouter";
import { PrivateRouter } from "./app/route/PrivateRouter";
import { PrivateAdminRouter } from "./app/route/PrivateAdminRouter";
import { LoginRouter } from "./app/route/LoginRouter";
import { RegistrationStatusProvider } from "./app/provider/RegistrationStatusProvider";
import { AdminListPage } from "./app/view/admin/list/AdminListPage";
import { DashBoard } from "./app/view/dash_board/DashBoard";
import { Toaster } from "react-hot-toast";
import { FAQListPage } from "./app/view/faq/FAQListPage";
import { FAQAddPage } from "./app/view/faq/FAQAddPage";
import { FAQEditPage } from "./app/view/faq/FAQEditPage";
import { TestPaths } from "./TestPaths";
import { TestDataAdminRouter } from "./app/route/TestDataAdminRouter";
import { AdminTestDataRegister } from "./app/view/admin/test_data/AdminTestDataRegister";
import { LoginLogList } from "./app/view/admin/login_log/LoginLogList";
import { CareCommentAnalysisPage } from "./app/view/admin/care_comment_analysis/CareCommentAnalysisPage";
import { ChangePasswordPage } from "./app/view/change_password/ChangePasswordPage";
import { AdminOperationLogPage } from "./app/view/admin/admin_operation_log/AdminOperationLogPage";
import InquiryList from "./app/view/admin/inquiry/InquiryList";
import InquiryDetail from "./app/view/inquiry/InquiryDetail";
import { Routes, Route } from "react-router-dom";
import { InquiryCompletedPage } from "./app/view/inquiry/InquiryCompletedPage";
import { InquiryFormPage } from "./app/view/inquiry/InquiryFormPage";
import { CareCommentListPage } from "./app/view/care_comment/CareCommentListPage";
import { CareRecipientConfigPage } from "./app/view/care_recipient/conifig/CareRecipientConfigPage";
import { VerifyContact } from "./app/view/contacts/VerifyContact";
import { AddCareRecipientPage } from "./app/view/care_recipient/new/AddCareRecipientPage";

function App() {
    const WithSideMenu = (props: {children: ReactNode}) => {
        return (
            <>
                <GlobalHeader withSideMenu />
                <div className={"with_side_menu_pages"}>
                    <main className={"main"}>
                        { props.children }
                    </main>
                </div>
            </>
        );
    };

    const NoSideMenu = (props: {children: ReactNode}) => {
        return (
            <>
                <GlobalHeader />
                <div className={"pages"}>
                    { props.children }
                </div>
            </>
        );
    };

    const ProtectedRoutes = () => {
        return (
            <Routes>
                <Route path={Paths.root} element={<RootRouter/>} />
                <Route path={Paths.role} element={<RoleRouter/>} />
                {/* 一般画面 */}
                <Route path={Paths.careRecipient} element={
                    <PrivateRouter>
                        <WithSideMenu>
                            <CareRecipientListPage/>
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={Paths.addCareRecipient} element={
                    <PrivateRouter>
                        <WithSideMenu>
                            <AddCareRecipientPage/>
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={"/care_recipient/config/:careRecipientId"} element={
                    <PrivateRouter>
                        <WithSideMenu>
                            <CareRecipientConfigPage />
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={`${Paths.information}${Paths.list}/:page`} element={
                    <PrivateRouter>
                        <WithSideMenu>
                            <InformationListPage/>
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={`${Paths.information}${Paths.list}`} element={
                    <PrivateRouter>
                        <WithSideMenu>
                            <InformationListPage/>
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={`${Paths.information}/:informationId`} element={
                    <PrivateRouter>
                        <WithSideMenu>
                            <InformationPage/>
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={`${Paths.faq}${Paths.list}`} element={
                    <PrivateRouter>
                        <WithSideMenu>
                            <FAQListPage />
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={Paths.notificationEmail} element={
                    <PrivateRouter >
                        <WithSideMenu>
                            <NotificationEmailPage/>
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={`${Paths.dashBoard}/:careRecipientId`} element={
                    <PrivateRouter >
                        <WithSideMenu>
                            <DashBoard/>
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={`${Paths.changePassword}`} element={
                    <PrivateRouter >
                        <WithSideMenu>
                            <ChangePasswordPage />
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={`${Paths.inquiry}`} element={
                    <PrivateRouter>
                        <WithSideMenu>
                            <InquiryFormPage/>
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route path={`${Paths.inquiryCompleted}`} element={
                    <PrivateRouter>
                        <WithSideMenu>
                            <InquiryCompletedPage/>
                        </WithSideMenu>
                    </PrivateRouter>
                } />
                <Route  path={`${Paths.careComment}/:careRecipientId`} element={
                    <PrivateRouter>
                        <WithSideMenu>
                            <CareCommentListPage/>
                        </WithSideMenu>
                    </PrivateRouter>
                } /> 
                {/* 管理画面 */}
                <Route path={Paths.admin} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <AdminIndexPage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.serviceProvider}${Paths.list}`} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <AdminServiceProviderListPage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.serviceProvider}${Paths.edit}/:serviceProviderId`} element={
                    <PrivateAdminRouter >
                        <NoSideMenu>
                            <AdminServiceProviderUpdatePage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.serviceProvider}${Paths.add}`} element={
                    <PrivateAdminRouter >
                        <NoSideMenu>
                            <AdminServiceProviderAddPage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.user}${Paths.list}`} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <AdminUserListPage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.user}${Paths.edit}/:userId`} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <AdminUserUpdatePage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.user}${Paths.add}`} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <AdminUserAddPage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.careRecipient}${Paths.list}`} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <AdminCareRecipientListPage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.careRecipient}${Paths.edit}/:careRecipientId`} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <AdminCareRecipientEditPage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } /> 
                <Route path={`${Paths.admin}${Paths.careRecipient}${Paths.add}`} element={
                    <PrivateAdminRouter >
                        <NoSideMenu>
                            <AdminCareRecipientAddPage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.careComment}${Paths.add}/:careRecipientId`} element={
                    <PrivateAdminRouter >
                        <NoSideMenu>
                            <AdminCareCommentAddPage />
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.information}${Paths.add}`} element={
                    <PrivateAdminRouter >
                        <NoSideMenu>
                            <InformationAddPage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}/list`} element={
                    <PrivateAdminRouter >
                        <NoSideMenu>
                            <AdminListPage/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.faq}${Paths.add}`} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <FAQAddPage />
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.faq}${Paths.edit}/:faqId`} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <FAQEditPage />
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } /> 
                <Route path={`${Paths.admin}${Paths.loginLog}`} element={
                    <PrivateAdminRouter >
                        <NoSideMenu>
                            <LoginLogList />
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.careCommentAnalysis}`} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <CareCommentAnalysisPage />
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.adminOperationLog}`} element={
                    <PrivateAdminRouter >
                        <NoSideMenu>
                            <AdminOperationLogPage />
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.inquiry}`} element={
                    <PrivateAdminRouter >
                        <NoSideMenu>
                            <InquiryList/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />
                <Route path={`${Paths.admin}${Paths.inquiry}/:inquiryId`} element={
                    <PrivateAdminRouter>
                        <NoSideMenu>
                            <InquiryDetail/>
                        </NoSideMenu>
                    </PrivateAdminRouter>
                } />

                {/* テストデータ登録画面(production以外で表示) */}
                <Route path={`${TestPaths.testData}${TestPaths.estimatedBehavior}/:careRecipientId`} element={
                    <TestDataAdminRouter>
                        <NoSideMenu>
                            <AdminTestDataRegister />
                        </NoSideMenu>
                    </TestDataAdminRouter>
                } />
                <Route path={Paths.notRegistration} element={
                    <NoSideMenu>
                        <NotRegistrationPage/>
                    </NoSideMenu>
                } />
                <Route path={"/*"} element={
                    <NoSideMenu>
                        <NotFoundPage/>
                    </NoSideMenu>
                } />
            </Routes>
        );
    };

    return (
        <BrowserRouter>
            <div className="App">
                <Toaster/>
                <Routes>
                    <Route path={Paths.login} element={<LoginRouter/>} />
                    <Route path={"verify-email/:contactId"} element={<VerifyContact />} />
                    <Route
                        path="/*"
                        element={
                            <RegistrationStatusProvider>
                                <ProtectedRoutes />
                            </RegistrationStatusProvider>
                        }
                    />
                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;
